// extracted by mini-css-extract-plugin
export var accInfoMessageBar = "Y0RyX";
export var accMessageBar = "tI86l";
export var accMessageBarActions = "Cb61H";
export var accMessageBarDismissIcon = "rxrYP";
export var accMessageBarIcon = "RG80V";
export var accMessageBarLink = "_bN3k";
export var accMessageBarText = "BIohF";